import React from "react";
import logo from "../res/logo2.png"

export default function MainLoading() {
    return <div className="main-loading text-center">
        <img src={logo} width="300px" />
    </div>
}